import React from 'react';
import { StyleSheet, Text, View } from './rn';
import type { Message } from '../services/api';
import { useTheme } from '../theme/ThemeContext';
import { useTranslation } from '../i18n/I18nContext';

/** Only metadata already returned for this viewer; absence is not evidence of unread/delivery. */
export function messageInfoRows(message: Message, myId: number, lang: string) {
  const rows: { key: string; value: string }[] = [];
  const dateRow = (key: string, value?: string | null) => {
    if (!value || !Number.isFinite(Date.parse(value))) return;
    rows.push({ key, value: new Date(value).toLocaleString(lang, {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit',
    }) });
  };
  dateRow('message.infoSentAt', message.created_at);
  if (message.sender_id === myId) dateRow('message.infoReadAt', message.read_at);
  dateRow('message.edited', message.edited_at);
  const platform = message.sent_via === 'web' ? 'Web' : message.sent_via === 'ios' ? 'iOS'
    : message.sent_via === 'android' ? 'Android' : null;
  if (platform) rows.push({ key: 'message.infoPlatform', value: platform });
  return rows;
}

export default function MessageInfoDetails({ message, myId }: { message: Message; myId: number }) {
  const colors = useTheme(); const { t, lang } = useTranslation();
  return <View testID="message-info-details" style={styles.body}>
    <Text accessibilityRole="header" style={[styles.title, { color: colors.black }]}>{t('message.info')}</Text>
    {messageInfoRows(message, myId, lang).map(row => <View key={row.key} style={styles.row}>
      <Text style={[styles.label, { color: colors.gray600 }]}>{t(row.key)}</Text>
      <Text testID={row.key} style={[styles.value, { color: colors.black }]}>{row.value}</Text>
    </View>)}
  </View>;
}
const styles = StyleSheet.create({
  body: { paddingHorizontal: 18, paddingBottom: 16, gap: 16 },
  title: { fontSize: 18, lineHeight: 25, fontWeight: '600' },
  row: { gap: 4, minWidth: 0 }, label: { fontSize: 14, lineHeight: 21 }, value: { fontSize: 16, lineHeight: 24, flexShrink: 1 },
});
